import request from '@/router/axios';
// 月度总销量分物资
export const getMonthShipment = () => {
  return request({
    url: '/api/blade-app/screendisplay/monthShipment',
    method: 'post',

  })
}
// 日销量分物资
export const getDayShipment = () => {
  return request({
    url: '/api/blade-app/screendisplay/dayShipment',
    method: 'post',
  })
}
// 周销量
export const getWeekShipment = () => {
  return request({
    url: '/api/blade-app/screendisplay/weekShipment',
    method: 'post',
  })
}

// 月度销量 一至当前月
export const getYearShipment = () => {
  return request({
    url: '/api/blade-app/screendisplay/yearShipment',
    method: 'post',
  })
}

// 日销量车数
export const getDayTrend = () => {
  return request({
    url: '/api/blade-app/screendisplay/dayTrend',
    method: 'post',
  })
}
// 汇总数据
export const getSummaryShipment = () => {
  return request({
    url: '/api/blade-app/screendisplay/summaryShipment',
    method: 'post',
  })
}

// 实时出厂
export const getRealTimeShipment = () => {
  return request({
    url: '/api/blade-app/screendisplay/realTimeShipment',
    method: 'post',
  })
}




